import styled from "styled-components";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 20px;
`;

export const ModalContent = styled.div`
  background: var(--surface);
  border-radius: 12px;
  max-width: 700px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  border: 1px solid var(--accent-light);
  /* Fix za Chrome glitch pri brzom skrolu (providan/pomeren sadržaj) */
  transform: translateZ(0);
  overscroll-behavior: contain;
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 32px;
  border-bottom: 1px solid var(--accent-light);
  background: var(--surface-light);
  border-radius: 12px 12px 0 0;
`;

export const ModalTitle = styled.h3`
  color: var(--text);
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;

  svg {
    color: var(--accent);
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 20px;
  color: var(--text-secondary);
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  transition: all 0.2s ease;

  &:hover {
    background: var(--surface-hover);
    color: var(--text);
  }
`;

export const ApplicationDetails = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  h4 {
    color: var(--text);
    margin: 0 0 8px 0;
    font-size: 1rem;
    font-weight: 600;
    border-bottom: 2px solid var(--accent);
    padding-bottom: 4px;
  }

  p {
    color: var(--text-secondary);
    margin: 4px 0;
    line-height: 1.5;

    strong {
      color: var(--text);
      font-weight: 600;
    }
  }

  > div {
    background: var(--surface-light);
    padding: 16px;
    border-radius: 8px;
    border: 1px solid var(--accent-light);
  }
`;

export const ReviewForm = styled.form`
  background: var(--surface);
  border-radius: 8px;
  padding: 20px;
  margin-top: 8px;
`;

export const FormGroup = styled.div`
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }

  input {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid var(--accent-light);
    border-radius: 6px;
    background: var(--surface);
    color: var(--text);
    font-size: 0.875rem;
    transition: border-color 0.2s ease;

    &:focus {
      outline: none;
      border-color: var(--accent);
    }

    &::placeholder {
      color: var(--text-secondary);
    }
  }
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 6px;
  font-weight: 500;
  color: var(--text);
  font-size: 0.875rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--accent-light);
  border-radius: 6px;
  background: var(--surface);
  color: var(--text);
  font-size: 0.875rem;
  font-family: inherit;
  resize: vertical;
  min-height: 80px;
  transition: border-color 0.2s ease;

  &:focus {
    outline: none;
    border-color: var(--accent);
  }

  &::placeholder {
    color: var(--text-secondary);
  }
`;

export const SubmitButton = styled.button`
  background: var(--accent);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
  margin-top: 8px;

  &:hover:not(:disabled) {
    background: var(--accent-dark);
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;

export const VideoLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: var(--accent);
  color: white;
  text-decoration: none;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s ease;

  &:hover {
    background: var(--accent-dark);
    transform: translateY(-1px);
  }

  svg {
    font-size: 0.75rem;
  }
`;

export const HiddenFileInput = styled.input`
  display: none;
`;

export const CustomUploadButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: var(--accent);
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: var(--accent-dark);
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }

  svg {
    font-size: 0.875rem;
  }
`;

export const ImagePreviewGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 12px;
  margin-top: 16px;
`;

export const ImagePreviewItem = styled.div`
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid var(--accent-light);
  background: var(--surface-light);
`;

export const PreviewImage = styled.img`
  width: 100%;
  height: 120px;
  object-fit: cover;
  display: block;
`;

export const DeleteImageButton = styled.button`
  position: absolute;
  top: 4px;
  right: 4px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: var(--error);
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 1);
    transform: scale(1.1);
  }
`;

export const ImageName = styled.p`
  padding: 8px;
  margin: 0;
  font-size: 11px;
  color: var(--text-muted);
  text-align: center;
  word-break: break-all;
  line-height: 1.2;
`;

// Novi stilovi
export const WorkImagesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 10px;
  margin-top: 10px;
`;

export const WorkImageItem = styled.div`
  text-align: center;
  cursor: pointer;
`;

export const WorkImage = styled.img`
  width: 100%;
  height: 150px;
  object-fit: cover;
  border-radius: 8px;
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.02);
  }
`;

export const WorkImageName = styled.p`
  font-size: 12px;
  margin: 5px 0;
  color: var(--text-muted);
`;

export const SelectedFileInfo = styled.div`
  margin-top: 10px;
  font-size: 14px;
  color: var(--success);
`;

export const ApprovedStatus = styled.div`
  text-align: center;
  padding: 20px;

  p {
    color: var(--success);
    font-weight: bold;
    margin-bottom: 12px;
  }
`;

export const FullscreenOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20000;
  cursor: pointer;
  padding: 20px;
`;

export const FullscreenImage = styled.img`
  max-width: 95%;
  max-height: 95vh;
  object-fit: contain;
  border-radius: 4px;
`;

export const FullscreenCloseButton = styled.button`
  position: fixed;
  top: 16px;
  right: 16px;
  background: rgba(255, 255, 255, 0.15);
  border: none;
  color: white;
  font-size: 24px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20001;
  transition: background 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }
`;

export const CertificateLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: var(--accent);
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: var(--accent-dark);
  }

  svg {
    font-size: 1rem;
  }
`;
